import React from 'react';
import { Plus } from 'lucide-react';

export interface GsHeaderProps {
  pageTitle: string;
  onAddClick?: () => void;
  addButtonLabel?: string;
  trailingSlot?: React.ReactNode;
}

export function GsHeader({ onAddClick, addButtonLabel, trailingSlot }: GsHeaderProps) {
  const showActions = trailingSlot != null || onAddClick != null;

  // Modèle D — pas de titre dans le header
  // bg-[#fbfbfb] light / dark:bg-slate-900 dark — filet bottom
  if (!showActions) {
    return (
      <div className="h-px shrink-0 bg-[#ececec] dark:bg-slate-800" />
    );
  }

  return (
    <header className="flex h-10 min-h-[40px] shrink-0 items-center justify-end px-5
                       bg-[#fbfbfb] dark:bg-slate-900
                       border-b border-[#ececec] dark:border-slate-800">
      <div className="flex shrink-0 items-center gap-2">
        {trailingSlot}
        {onAddClick != null && (
          <button
            type="button"
            onClick={() => onAddClick()}
            className="inline-flex h-7 items-center justify-center rounded-md
                       border border-[#fed7aa] bg-[#fff7ed] px-2.5
                       text-[11px] font-medium text-[#c2410c]
                       transition-colors hover:bg-[#ffedd5]
                       dark:border-orange-900/40 dark:bg-orange-950/40 dark:text-orange-300"
            title="Ajouter"
          >
            {addButtonLabel != null && addButtonLabel !== '+' ? (
              addButtonLabel
            ) : (
              <Plus className="h-3.5 w-3.5 shrink-0" strokeWidth={2.5} />
            )}
          </button>
        )}
      </div>
    </header>
  );
}
